import * as React from 'react'

export const SVG_Cross_WithCircle = (props: { color?: string; className?: string }) => (
    <svg width="30px" height="30px" viewBox="0 0 46 46" version="1.1" className={props.className}>
        <g id="a" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="11″-iPad-Pro" transform="translate(-710.000000, -230.000000)">
                <g id="Cross" transform="translate(710.000000, 230.000000)">
                    <circle id="Oval-7" fill={props.color || '#ED2B50'} cx="23" cy="23" r="23"></circle>
                    <path
                        d="M30.9466952,13.5241644 L23.4999288,20.9702531 L16.0533668,13.5241644 C15.3545665,12.8253733 14.2213815,12.8253733 13.5234589,13.5247346 L13.3639087,13.7073623 C12.8301759,14.4085036 12.8835492,15.4129962 13.5240286,16.0534672 L20.9702237,23.4999223 L13.5240286,30.9466039 C12.8253238,31.6452995 12.8253238,32.777211 13.5240286,33.4759066 L13.706943,33.6360463 C14.4072291,34.1698451 15.4127999,34.1164652 16.0533668,33.4759066 L23.4999288,26.0295915 L30.9466952,33.4759066 C31.6454955,34.1746978 32.7778628,34.1746978 33.4757853,33.4753364 L33.6360048,33.2923531 C34.1700648,32.5918653 34.1165711,31.5866252 33.4746467,30.9460355 L26.0276894,23.4999223 L33.4752438,16.0534391 C34.1749279,15.3552104 34.1749279,14.2224212 33.4746467,13.523596 C32.7778628,12.8253733 31.6454955,12.8253733 30.9466952,13.5241644 Z"
                        id="Fill-1"
                        fill="#FFFFFF"
                        fillRule="nonzero"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
)
